module.exports = __webpack_public_path__ + "img/5641471.jpg";